import { useFormik } from 'formik'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CRow,
  CFormSelect,
  CFormLabel,
  CFormTextarea,
  CButton,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
  CInputGroup,
  CInputGroupText,
  CTooltip,
  CLink,
  CTableRow,
} from '@coreui/react-pro'

import React, { useEffect, useState, useRef } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import ToastComponent from 'src/components/common/TaostComponent'
import ScorecardService from 'src/service/ScorecardService'
import CompleteMarkModal from './CompleteMarkModal'
import ClubService from 'src/service/ClubService'
import moment from 'moment'
import Loader from 'src/components/Loader'
import CIcon from '@coreui/icons-react'
import { cilInfo } from '@coreui/icons'
import MarkAsCompleteModal from './MarkAsCompleteModal'

const CommonFullScoreCard = () => {
  const [scorecardColoumns, setScorecardColoumns] = useState([])
  const navigate = useNavigate()
  const [visible, setVisible] = useState(false)
  const [completMarkModalVisible, setCompletMarkModalVisible] = useState(false)
  const [finalScorecardModalVisible, setFinalScorecardModalVisible] = useState(false)
  const [defaultInning, setDefaultInning] = useState(1)
  const [scorecardDetails, setScorecardDetails] = useState([])
  const [playerList, setPlayerList] = useState([])
  const [fixtureDetails, setFixtureDetails] = useState({})
  const [loader, setLoader] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [statusValue, setStatusValue] = useState()
  const param = useParams()
  const [gameDetails, setGameDetails] = useState({})

  const fetchData = async (defaultInning = 1) => {
    setScorecardDetails([])
    try {
      const scorecardResponse = await ScorecardService.fullScorecardDetail(
        param.fixtureId,
        defaultInning,
      )
      if (scorecardResponse.status === 200) {
        setScorecardDetails(scorecardResponse.data)
        setScorecardColoumns(scorecardResponse.scorecardColoumns)
        if (scorecardResponse.player_list.length < 5) {
          ToastComponent(
            'Please add a minimum of 5 players to the squad list of this fixture!',
            'error',
          )
          navigate(`/manage-scores/team-players/${param.fixtureId}`)
          return // Exit early if player list is insufficient
        }
        setPlayerList(scorecardResponse.player_list)
        setFixtureDetails(scorecardResponse.fixtureDetails)
        setStatusValue(scorecardResponse.fixtureDetails.status)
      }

      const clubResponse = await ClubService.getClubDetails()
      if (clubResponse.status === 200) {
        setLoader(false)
        setIsLoading(false)
        setGameDetails(clubResponse.game_details)
      }
    } catch (error) {
      console.error('Error fetching data:', error)
      // Handle error here, e.g., show an error toast
    }
  }

  useEffect(() => {
    fetchData()
    // Cleanup (if necessary)
    return () => {
      // Cleanup code here (if any)
    }
  }, [])
  const formik = useFormik({
    initialValues: {
      data: scorecardDetails,
      scorcard_link_name: fixtureDetails?.scorcard_link_name,
      scorcard_link_url: fixtureDetails?.scorcard_link_url,
      fall_of_wickets: fixtureDetails?.fall_of_wickets,
      match_report: fixtureDetails?.match_report,
      potm_match_status: fixtureDetails?.potm_match_status ?? 0,
      potm_match_status2: fixtureDetails?.potm_match_status2 ?? 0,
      potm: fixtureDetails?.potm ?? [], // for Team 1
      potm2: fixtureDetails?.potm2 ?? [], // for Team 2
      match_status: '',
    },
    enableReinitialize: true,
    onSubmit: (data, actions) => {
      data.fixtureId = param.fixtureId
      // data.potm = selectedValue
      data.status = statusValue
      data.inning = defaultInning
      setLoader(true)
      if (gameDetails?.game_type === 3) {
        ScorecardService.saveIndoorScorecard(data).then((res) => {
          if (res.status === 200) {
            fetchData()
            setLoader(false)
            ToastComponent(res.message, 'success')
          }
        })
      } else {
        ScorecardService.saveScorecard(data).then((res) => {
          if (res.status === 200) {
            fetchData()
            setLoader(false)
            ToastComponent(res.message, 'success')
          }
        })
      }
    },
  })
  const [selectedValue, setSelectedValue] = useState([])
  const handleChange = (e) => {
    setSelectedValue(Array.isArray(e) ? e.map((x) => x.value) : [])
  }
  const [completeMarkModalData, setCompleteMarkModalData] = useState([])
  const handleMatchStatus = (e) => {
    setStatusValue(e.target.value)
    const data = {}
    data.fixtureId = param.fixtureId
    data.status = e.target.value
    if (e.target.value === '2') {
      ScorecardService.getSavedScorecardData(data).then((res) => {
        if (res.status === 200) {
          setCompleteMarkModalData(res.data)
          setCompletMarkModalVisible(true)
        }
      })
    } else {
      // formikRef.current.handleSubmit()
      ScorecardService.changFixtureStatus(param.fixtureId, e.target.value)
        .then((res) => {
          if (res.status === 200) {
            ToastComponent(res.message, 'success')
            navigate(`/full-scorecard/${param.fixtureId}`)
          }
        })
        .catch((e) => {
          console.log('e', e)
          ToastComponent('Something went wrong.', 'error')
        })
    }
  }

  const formikRef = React.useRef()
  useEffect(() => {
    formikRef.current = formik
  }, [formik])

  const changeInning = (e) => {
    setDefaultInning(e.target.value)
    fetchData(e.target.value)
  }

  const [isMobile, setIsMobile] = useState(false)
  // Function to update the isMobile state based on the screen width
  const updateScreenSize = () => {
    setIsMobile(window.innerWidth <= 768) // Adjust the breakpoint as needed
  }
  // Use useEffect to update the screen size state on component mount and window resize
  useEffect(() => {
    updateScreenSize() // Initial check
    window.addEventListener('resize', updateScreenSize)

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', updateScreenSize)
    }
  }, [])
  function formatFantasyPoints(fantasyPoints) {
    // Check if there are decimal digits
    if (fantasyPoints % 1 !== 0) {
      return fantasyPoints.toFixed(2).replace(/0+$/, '') // Remove trailing zeros
    } else {
      return fantasyPoints.toString() // Convert to a string without decimal places
    }
  }
  const [infoPageModal, setInfoPageModal] = useState(false)
  const handleInfoClick = () => {
    setInfoPageModal(true)
  }
  const debounceRef = useRef(null)

  const debounceUpdate = (callback, delay = 800) => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current)
    }

    debounceRef.current = setTimeout(() => {
      callback()
    }, delay)
  }

  const handleInputChange = (event, type) => {
    formik.handleChange(event)

    const value = event.target.value

    debounceUpdate(async () => {
      const data = {
        fixtureId: param.fixtureId,
        type,
        value,
      }

      try {
        const res = await ScorecardService.updateCustomScorecardField(data)
        if (res?.status === 200) {
          ToastComponent(res.message, 'success')
        }
      } catch (e) {
        ToastComponent('Save failed', 'error')
      }
    })
  }

  const dropdownCol1 = [{ key: 'sc' }]
  const dropdownCol2 = [
    { key: 'hw' },
    { key: 'aw' },
    { key: 'al' },
    { key: 'hl' },
    { key: 'ssw' },
    { key: 'ssls' },
    { key: 'owt' },
    { key: 'bwm' },
    { key: 'blm' },
  ]

  return (
    <>
      <>
        <CForm className="row g-3" onSubmit={formik.handleSubmit}>
          <CRow>
            <CCol xs={12} md={3} className="pt-3 pb-2">
              <span>
                <b> Round</b>: {fixtureDetails.round}
              </span>
            </CCol>
            <CCol xs={12} md={3} className="pt-3 pb-2">
              <span>
                <b> Team</b>: {fixtureDetails.team_name}
              </span>
            </CCol>
            <CCol xs={12} md={3} className="pt-3 pb-2">
              <span>
                <b> Start Date/Time</b>: {moment(fixtureDetails.start_date).format('D.MM.YYYY')}
                {', '}
                {moment(fixtureDetails.start_time, ['HH:mm']).format('h:mma')}
              </span>
            </CCol>
            <CCol xs={12} md={3} className="pt-3 pb-2">
              <span>
                <b> End Date/Time</b>: {moment(fixtureDetails.end_date).format('D.MM.YYYY')}
                {', '}
                {moment(fixtureDetails.end_time, ['HH:mm']).format('h:mma')}
              </span>
            </CCol>

            {fixtureDetails?.match_type === '2-Day' && (
              <CCol xs={12} md={3} className="pt-3 pb-2">
                <CFormLabel className="fw-bold" htmlFor="Country">
                  Inning
                </CFormLabel>
                <CFormSelect
                  aria-label="select inning"
                  name="inning"
                  onChange={changeInning}
                  className={
                    'form-control' +
                    (formik.errors.inning && formik.touched.inning ? ' is-invalid' : '')
                  }
                  id="inning"
                >
                  <option value={1}>1st Innings</option>
                  <option value={2}>2nd Innings</option>
                </CFormSelect>
              </CCol>
            )}

            {isMobile ? (
              <CCol xs={12}>
                <CCard className="mb-4">
                  <CCardHeader>
                    <strong>
                      <strong>
                        {fixtureDetails.scorcard_link_url ? (
                          <Link to={fixtureDetails.scorcard_link_url} target="_blank">
                            Scorecard
                          </Link>
                        ) : (
                          'Scorecard'
                        )}
                      </strong>
                    </strong>
                  </CCardHeader>
                  <CCardBody>
                    {loader ? (
                      <Loader />
                    ) : (
                      <CAccordion alwaysOpen>
                        {scorecardDetails &&
                          scorecardDetails.map((item, key) => (
                            <CAccordionItem itemKey={key} key={key}>
                              <CAccordionHeader>{item.player_name}</CAccordionHeader>

                              <CAccordionBody>
                                <CRow className="mb-2">
                                  {/* Fantasy Points */}
                                  <div className="col-md-2 col-sm">
                                    <CInputGroup className="mb-2">
                                      <CInputGroupText style={{ width: '135px' }}>
                                        Fantasy Points
                                      </CInputGroupText>
                                      <CFormInput
                                        disabled
                                        value={formatFantasyPoints(item.fantasy_points)}
                                      />
                                    </CInputGroup>
                                  </div>

                                  {/* Dynamic scorecard fields */}
                                  {scorecardColoumns.map((col) => {
                                    const keyName = col.attribute_key
                                    const value = item[keyName]

                                    // sc → numeric
                                    if (dropdownCol1.some((d) => d.key === keyName)) {
                                      return (
                                        <div className="col-md-2 col-sm" key={keyName}>
                                          <CInputGroup className="mb-2">
                                            <CInputGroupText style={{ width: '135px' }}>
                                              {col.label}
                                            </CInputGroupText>
                                            <CFormInput disabled value={value ?? 0} />
                                          </CInputGroup>
                                        </div>
                                      )
                                    }

                                    // hw, aw, al, hl, ssw, ssls, owt, bwm, blm → Yes / No
                                    if (dropdownCol2.some((d) => d.key === keyName)) {
                                      return (
                                        <div className="col-md-2 col-sm" key={keyName}>
                                          <CInputGroup className="mb-2">
                                            <CInputGroupText style={{ width: '135px' }}>
                                              {col.label}
                                            </CInputGroupText>
                                            <CFormInput
                                              disabled
                                              value={value == 1 ? 'Yes' : 'No'}
                                            />
                                          </CInputGroup>
                                        </div>
                                      )
                                    }

                                    // fallback (any future backend column)
                                    return (
                                      <div className="col-md-2 col-sm" key={keyName}>
                                        <CInputGroup className="mb-2">
                                          <CInputGroupText style={{ width: '135px' }}>
                                            {col.label}
                                          </CInputGroupText>
                                          <CFormInput disabled value={value ?? '-'} />
                                        </CInputGroup>
                                      </div>
                                    )
                                  })}
                                </CRow>
                              </CAccordionBody>
                            </CAccordionItem>
                          ))}
                      </CAccordion>
                    )}
                  </CCardBody>
                </CCard>
              </CCol>
            ) : (
              <CCol xs={12}>
                <CCard className="mb-4">
                  <CCardHeader>
                    <strong>
                      {fixtureDetails.scorcard_link_url ? (
                        <Link to={fixtureDetails.scorcard_link_url} target="_blank">
                          Scorecard
                        </Link>
                      ) : (
                        'Scorecard'
                      )}
                    </strong>
                  </CCardHeader>
                  <CCardBody>
                    {loader ? (
                      <Loader />
                    ) : (
                      <div className="table-responsive" style={{ overflowX: 'auto' }}>
                        <table
                          className="main-table table innertable"
                          style={{ borderCollapse: 'collapse', width: '100%' }}
                        >
                          <thead>
                            <tr>
                              <th>PLAYER</th>
                              <th>
                                <CTooltip content="Position">
                                  <CLink>POS</CLink>
                                </CTooltip>
                              </th>
                              <th>
                                <CTooltip content="Fantasy Points">
                                  <CLink>FP</CLink>
                                </CTooltip>
                              </th>
                              {scorecardColoumns.map((col) => (
                                <th key={col.id}>
                                  <CTooltip content={col.full_name}>
                                    <CLink>{col.label}</CLink>
                                  </CTooltip>
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {scorecardDetails &&
                              scorecardDetails.map((item, rowIndex) => (
                                <CTableRow key={rowIndex}>
                                  {/* PLAYER */}
                                  <td
                                    style={{
                                      position: 'sticky',
                                      left: 0,
                                      zIndex: 1,
                                      backgroundColor: '#f9f9f9',
                                      minWidth: '150px',
                                    }}
                                  >
                                    {item.player_name}
                                  </td>

                                  {/* POSITION */}
                                  <td>
                                    {item.player_position === 1 && 'GPA'}
                                    {item.player_position === 2 && 'GPB'}
                                    {item.player_position === 3 && 'GPC'}
                                    {item.player_position === 4 && 'GPD'}
                                  </td>

                                  {/* FANTASY POINTS */}
                                  <td>{formatFantasyPoints(item.fantasy_points)}</td>

                                  {/* READ-ONLY SCORECARD COLUMNS */}
                                  {scorecardColoumns.map((col) => {
                                    const key = col.attribute_key
                                    const value = item[key]

                                    // sc → numeric
                                    if (dropdownCol1.some((d) => d.key === key)) {
                                      return <td key={key}>{value ?? 0}</td>
                                    }

                                    // hw, aw, al, hl, ssw, ssls, owt, bwm, blm → Yes / No
                                    if (dropdownCol2.some((d) => d.key === key)) {
                                      return <td key={key}>{value == 1 ? 'Yes' : 'No'}</td>
                                    }

                                    // fallback (if backend adds new column later)
                                    return <td key={key}>{value ?? '-'}</td>
                                  })}
                                </CTableRow>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </CCardBody>
                </CCard>
              </CCol>
            )}
            <CCol xs={12}>
              <CCard className="mb-4">
                <CCardHeader>
                  <strong>Scorecard Details</strong>
                </CCardHeader>
                <CCardBody>
                  <CRow>
                    <CCol md={6}>
                      <CFormLabel htmlFor="phone">Scorecard Source</CFormLabel>
                      <input
                        type="text"
                        name="scorcard_link_name"
                        className={'form-control'}
                        id="scorcard_link_name"
                        placeholder="Scorecard Source"
                        defaultValue={formik.values.scorcard_link_name}
                        onChange={(e) => handleInputChange(e, 'scorcard_link_name')}
                      />
                    </CCol>
                    <CCol md={6}>
                      <CFormLabel htmlFor="phone">Scorecard Link</CFormLabel>
                      <input
                        type="text"
                        name="scorcard_link_url"
                        className={'form-control'}
                        id="scorcard_link_url"
                        placeholder="Scorecard Link"
                        defaultValue={formik.values.scorcard_link_url}
                        onChange={(e) => handleInputChange(e, 'scorcard_link_url')}
                      />
                    </CCol>

                    <CCol md={6}>
                      <CFormLabel htmlFor="fall_of_wickets" className="mt-3">
                        Fall of Wickets
                      </CFormLabel>
                      <CFormTextarea
                        aria-label="With textarea"
                        defaultValue={formik.values.fall_of_wickets}
                        name={'fall_of_wickets'}
                        onChange={(e) => handleInputChange(e, 'fall_of_wickets')}
                      ></CFormTextarea>
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>
              <CompleteMarkModal visible={visible} setVisible={setVisible} />
            </CCol>
            <CCol xs={12}>
              <CCard className="mb-4 mt-3">
                <CCardHeader>
                  <strong>Match Status</strong>
                </CCardHeader>
                <CCardBody>
                  <CRow>
                    <CCol md={6}>
                      <CFormLabel htmlFor="Add Match Report" className="mr-1 mt-3">
                        Match Status
                      </CFormLabel>
                      <CButton color="danger" size="sm" onClick={() => setVisible(!visible)}>
                        <CIcon icon={cilInfo} className="" fontSize={12} />
                      </CButton>
                      <CFormSelect
                        aria-label="Select Structure"
                        name="match_status"
                        className={
                          'mt-3 form-control' +
                          (formik.errors.match_status && formik.touched.match_status
                            ? ' is-invalid'
                            : '')
                        }
                        value={statusValue}
                        id="match_status"
                        onChange={handleMatchStatus}
                      >
                        <option value={0}>Select Match Status </option>
                        <option value={1}>In-Progress</option>
                        <option value={2}>Completed</option>
                      </CFormSelect>
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </CForm>
        <CompleteMarkModal visible={visible} setVisible={setVisible} />
        <MarkAsCompleteModal
          completMarkModalVisible={completMarkModalVisible}
          setCompletMarkModalVisible={setCompletMarkModalVisible}
          data={completeMarkModalData}
          fixtureId={param.fixtureId}
          finalScorecardModalVisible={finalScorecardModalVisible}
          setFinalScorecardModalVisible={setFinalScorecardModalVisible}
        />
      </>
    </>
  )
}

export default CommonFullScoreCard
